import { Injectable } from '@angular/core';
import { AppConfig } from '../model/config.model';

interface BrandingConfig {
  mainLogo?: string;
  secondaryLogo?: string;
  primaryColor?: string;
  secondaryColor?: string;
  backgroundColor?: string;
  textColor?: string;
  buttonTextColor?: string;
  cardBackground?: string;
  cardBorder?: string;
  menuSelecionado?: string;
  gradientStart?: string;
  gradientEnd?: string;
  phoneEmpresa?: string;
  btnLoginPrimaryColor?: string;
  btnLoginsecondaryColor?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BrandingService {
  private config: AppConfig;
  private defaultColors = {
    primaryColor: '#0966A0',
    secondaryColor: '#13C6A8',
    backgroundColor: '#FFFFFF',
    textColor: '#1E293B',
    buttonTextColor: '#FFFFFF',
    cardBackground: '#FFFFFF',
    cardBorder: '#E8EDF3',
    menuSelecionado: '#FFFFFF',
    gradientStart: '#0A4E8A',
    gradientEnd: '#0F75C9',
    btnLoginPrimaryColor: '#0966A0',
    btnLoginsecondaryColor: '#13C6A8'
  };

  constructor() {
    this.config = (window as any).config || {};
  }

  get branding(): BrandingConfig {
    return this.config.branding || {};
  }

  getPrimaryColor(): string {
    return this.branding.primaryColor || this.defaultColors.primaryColor;
  }

  getSecondaryColor(): string {
    return this.branding.secondaryColor || this.deriveColorVariation(this.getPrimaryColor());
  }

  getBackgroundColor(): string {
    return this.branding.backgroundColor || this.defaultColors.backgroundColor;
  }

  getTextColor(): string {
    return this.branding.textColor || this.defaultColors.textColor;
  }

  getButtonTextColor(): string {
    return this.branding.buttonTextColor || this.defaultColors.buttonTextColor;
  }

  getCardBackground(): string {
    return this.branding.cardBackground || this.defaultColors.cardBackground;
  }

  getCardBorder(): string {
    return this.branding.cardBorder || this.defaultColors.cardBorder;
  }

  getGradientStart(): string {
    return this.branding.gradientStart || this.defaultColors.gradientStart;
  }

  getGradientEnd(): string {
    return this.branding.gradientEnd || this.defaultColors.gradientEnd;
  }

  getMainLogo(): string {
    return this.branding.mainLogo || '';
  }

  getSecondaryLogo(): string {
    return this.branding.secondaryLogo || '';
  }

  getPhoneEmpresa(): string {
    return this.branding.phoneEmpresa || '';
  }

  getBtnLoginPrimaryColor(): string {
    return this.branding.btnLoginPrimaryColor || this.defaultColors.btnLoginPrimaryColor;
  }

  getBtnLoginsecondaryColor(): string {
    return this.branding.btnLoginsecondaryColor || this.defaultColors.btnLoginsecondaryColor;
  }

  private deriveColorVariation(color: string): string {
    // Se a cor secundária não existir, gera uma variação da primária
    // Neste caso, aplica uma saturação/luminosidade diferente
    try {
      const c = parseInt(color.slice(1), 16);
      const r = (c >> 16) & 255;
      const g = (c >> 8) & 255;
      const b = c & 255;
      const lighter = this.lightenDarken(r, g, b, 30);
      return `rgb(${lighter.r}, ${lighter.g}, ${lighter.b})`;
    } catch (e) {
      return this.defaultColors.secondaryColor;
    }
  }

  private lightenDarken(r: number, g: number, b: number, percent: number) {
    return {
      r: Math.min(255, Math.round(r + (255 - r) * (percent / 100))),
      g: Math.min(255, Math.round(g + (255 - g) * (percent / 100))),
      b: Math.min(255, Math.round(b + (255 - b) * (percent / 100)))
    };
  }

  // Gera variáveis CSS que podem ser usadas em SCSS
  applyThemeVariables(): void {
    const root = document.documentElement;
    root.style.setProperty('--primary-color', this.getPrimaryColor());
    root.style.setProperty('--secondary-color', this.getSecondaryColor());
    root.style.setProperty('--background-color', this.getBackgroundColor());
    root.style.setProperty('--text-color', this.getTextColor());
    root.style.setProperty('--button-text-color', this.getButtonTextColor());
    root.style.setProperty('--card-background', this.getCardBackground());
    root.style.setProperty('--card-border', this.getCardBorder());
    root.style.setProperty('--gradient-start', this.getGradientStart());
    root.style.setProperty('--gradient-end', this.getGradientEnd());
    root.style.setProperty('--btn-login-primary-color', this.getBtnLoginPrimaryColor());
    root.style.setProperty('--btn-login-secondary-color', this.getBtnLoginsecondaryColor());
  }
}
